import React, { Component } from 'react';


class About extends Component {
  render() {
    return(
      <div className="aboutme-body">
        <h1>About Me</h1>
        <p>Currently learning</p>
      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/aboutme.js